import React from "react";

const experienceContent = [
  {
    year: "2021 - Present",
    position: "FULL STACK DEVELOPER",
    compnayName: "DIGIZONELABS",
    details: `It is a spanish based software compnay that i am working with as a lead full- stack developer maintaining older projects as well as building new projects from scratch.`,
  },
  {
    year: "2021 - Present",
    position: " FULL STACK DEVELOPER",
    compnayName: "NESL-IT",
    details: `I am working with Nesl-IT as a lead full-stack developer working directly with their clients on their projects as well as mentoring and guiding junior developers. I have been awarded top performer 2021 while working here.`,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
